import { render, staticRenderFns } from "./MediaUploadDialog.vue?vue&type=template&id=027b4fb6"
import script from "./MediaUploadDialog.vue?vue&type=script&lang=ts"
export * from "./MediaUploadDialog.vue?vue&type=script&lang=ts"
import style0 from "./MediaUploadDialog.vue?vue&type=style&index=0&id=027b4fb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports